/**
 * Logger utility that only logs in development mode
 * In production, all logs are suppressed to keep console clean
 */

const isDevelopment = process.env.NODE_ENV === 'development';

/**
 * Logger object that mimics console but only logs in development
 */
export const logger = {
  log: (...args) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
  
  debug: (...args) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },
  
  info: (...args) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },
  
  warn: (...args) => {
    // Warnings are shown in both dev and prod (they're important)
    console.warn(...args);
  },
  
  error: (...args) => {
    // Errors are always shown (they're critical)
    console.error(...args);
  },
  
  // Group methods (only in dev)
  group: (...args) => {
    if (isDevelopment) {
      console.group(...args);
    }
  },
  
  groupEnd: () => {
    if (isDevelopment) {
      console.groupEnd();
    }
  },
  
  // Table (only in dev)
  table: (...args) => {
    if (isDevelopment) {
      console.table(...args);
    }
  },
};

export default logger;

